import { render, staticRenderFns } from "./itemVideo3d.vue?vue&type=template&id=33abf04e"
import script from "./itemVideo3d.vue?vue&type=script&lang=ts"
export * from "./itemVideo3d.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports